import { Model } from "@interfaces/model.interface";

export interface Log extends Model {
	userId: number;
}

export class Log implements Log {
	userId = 0;

	constructor(data?: Partial<Log>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}